import { render, staticRenderFns } from "./KundenappHinweis.vue?vue&type=template&id=57b4bd94&scoped=true"
import script from "./KundenappHinweis.vue?vue&type=script&lang=js"
export * from "./KundenappHinweis.vue?vue&type=script&lang=js"
import style0 from "./KundenappHinweis.vue?vue&type=style&index=0&id=57b4bd94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b4bd94",
  null
  
)

export default component.exports